(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3823],{

/***/ 30753:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _code_; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/shared/lib/styled-jsx.js
var styled_jsx = __webpack_require__(69081);
var styled_jsx_default = /*#__PURE__*/__webpack_require__.n(styled_jsx);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 6 modules
var useTranslation = __webpack_require__(18132);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
;// CONCATENATED MODULE: ./node_modules/react-intersection-observer/react-intersection-observer.m.js



function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var observerMap = new Map();
var RootIds = new WeakMap();
var rootId = 0;
var unsupportedValue = undefined;
/**
 * What should be the default behavior if the IntersectionObserver is unsupported?
 * Ideally the polyfill has been loaded, you can have the following happen:
 * - `undefined`: Throw an error
 * - `true` or `false`: Set the `inView` value to this regardless of intersection state
 * **/

function defaultFallbackInView(inView) {
  unsupportedValue = inView;
}
/**
 * Generate a unique ID for the root element
 * @param root
 */

function getRootId(root) {
  if (!root) return '0';
  if (RootIds.has(root)) return RootIds.get(root);
  rootId += 1;
  RootIds.set(root, rootId.toString());
  return RootIds.get(root);
}
/**
 * Convert the options to a string Id, based on the values.
 * Ensures we can reuse the same observer when observing elements with the same options.
 * @param options
 */


function optionsToId(options) {
  return Object.keys(options).sort().filter(function (key) {
    return options[key] !== undefined;
  }).map(function (key) {
    return key + "_" + (key === 'root' ? getRootId(options.root) : options[key]);
  }).toString();
}

function createObserver(options) {
  // Create a unique ID for this observer instance, based on the root, root margin and threshold.
  var id = optionsToId(options);
  var instance = observerMap.get(id);

  if (!instance) {
    // Create a map of elements this observer is going to observe. Each element has a list of callbacks that should be triggered, once it comes into view.
    var elements = new Map();
    var thresholds;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var _elements$get;

        // While it would be nice if you could just look at isIntersecting to determine if the component is inside the viewport, browsers can't agree on how to use it.
        // -Firefox ignores `threshold` when considering `isIntersecting`, so it will never be false again if `threshold` is > 0
        var inView = entry.isIntersecting && thresholds.some(function (threshold) {
          return entry.intersectionRatio >= threshold;
        }); // @ts-ignore support IntersectionObserver v2

        if (options.trackVisibility && typeof entry.isVisible === 'undefined') {
          // The browser doesn't support Intersection Observer v2, falling back to v1 behavior.
          // @ts-ignore
          entry.isVisible = inView;
        }

        (_elements$get = elements.get(entry.target)) == null ? void 0 : _elements$get.forEach(function (callback) {
          callback(inView, entry);
        });
      });
    }, options); // Ensure we have a valid thresholds array. If not, use the threshold from the options

    thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [options.threshold || 0]);
    instance = {
      id: id,
      observer: observer,
      elements: elements
    };
    observerMap.set(id, instance);
  }

  return instance;
}
/**
 * @param element - DOM Element to observe
 * @param callback - Callback function to trigger when intersection status changes
 * @param options - Intersection Observer options
 * @param fallbackInView - Fallback inView value.
 * @return Function - Cleanup function that should be triggered to unregister the observer
 */


function observe(element, callback, options, fallbackInView) {
  if (options === void 0) {
    options = {};
  }

  if (fallbackInView === void 0) {
    fallbackInView = unsupportedValue;
  }

  if (typeof window.IntersectionObserver === 'undefined' && fallbackInView !== undefined) {
    var bounds = element.getBoundingClientRect();
    callback(fallbackInView, {
      isIntersecting: fallbackInView,
      target: element,
      intersectionRatio: typeof options.threshold === 'number' ? options.threshold : 0,
      time: 0,
      boundingClientRect: bounds,
      intersectionRect: bounds,
      rootBounds: bounds
    });
    return function () {// Nothing to cleanup
    };
  } // An observer with the same options can be reused, so lets use this fact


  var _createObserver = createObserver(options),
      id = _createObserver.id,
      observer = _createObserver.observer,
      elements = _createObserver.elements; // Register the callback listener for this element


  var callbacks = elements.get(element) || [];

  if (!elements.has(element)) {
    elements.set(element, callbacks);
  }

  callbacks.push(callback);
  observer.observe(element);
  return function unobserve() {
    // Remove the callback from the callback list
    callbacks.splice(callbacks.indexOf(callback), 1);

    if (callbacks.length === 0) {
      // No more callback exists for element, so destroy it
      elements["delete"](element);
      observer.unobserve(element);
    }

    if (elements.size === 0) {
      // No more elements are being observer by this instance, so destroy it
      observer.disconnect();
      observerMap["delete"](id);
    }
  };
}

var _excluded = ["children", "as", "triggerOnce", "threshold", "root", "rootMargin", "onChange", "skip", "trackVisibility", "delay", "initialInView", "fallbackInView"];

function isPlainChildren(props) {
  return typeof props.children !== 'function';
}
/**
 ## Render props

 To use the `<InView>` component, you pass it a function. It will be called
 whenever the state changes, with the new value of `inView`. In addition to the
 `inView` prop, children also receive a `ref` that should be set on the
 containing DOM element. This is the element that the IntersectionObserver will
 monitor.

 If you need it, you can also access the
 [`IntersectionObserverEntry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry)
 on `entry`, giving you access to all the details about the current intersection
 state.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView>
 {({ inView, ref, entry }) => (
      <div ref={ref}>
        <h2>{`Header inside viewport ${inView}.`}</h2>
      </div>
    )}
 </InView>
 );

 export default Component;
 ```

 ## Plain children

 You can pass any element to the `<InView />`, and it will handle creating the
 wrapping DOM element. Add a handler to the `onChange` method, and control the
 state in your own component. Any extra props you add to `<InView>` will be
 passed to the HTML element, allowing you set the `className`, `style`, etc.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView as="div" onChange={(inView, entry) => console.log('Inview:', inView)}>
 <h2>Plain children are always rendered. Use onChange to monitor state.</h2>
 </InView>
 );

 export default Component;
 ```
 */


var InView = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(InView, _React$Component);

  function InView(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.node = null;
    _this._unobserveCb = null;

    _this.handleNode = function (node) {
      if (_this.node) {
        // Clear the old observer, before we start observing a new element
        _this.unobserve();

        if (!node && !_this.props.triggerOnce && !_this.props.skip) {
          // Reset the state if we get a new node, and we aren't ignoring updates
          _this.setState({
            inView: !!_this.props.initialInView,
            entry: undefined
          });
        }
      }

      _this.node = node ? node : null;

      _this.observeNode();
    };

    _this.handleChange = function (inView, entry) {
      if (inView && _this.props.triggerOnce) {
        // If `triggerOnce` is true, we should stop observing the element.
        _this.unobserve();
      }

      if (!isPlainChildren(_this.props)) {
        // Store the current State, so we can pass it to the children in the next render update
        // There's no reason to update the state for plain children, since it's not used in the rendering.
        _this.setState({
          inView: inView,
          entry: entry
        });
      }

      if (_this.props.onChange) {
        // If the user is actively listening for onChange, always trigger it
        _this.props.onChange(inView, entry);
      }
    };

    _this.state = {
      inView: !!props.initialInView,
      entry: undefined
    };
    return _this;
  }

  var _proto = InView.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    // If a IntersectionObserver option changed, reinit the observer
    if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
      this.unobserve();
      this.observeNode();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.unobserve();
    this.node = null;
  };

  _proto.observeNode = function observeNode() {
    if (!this.node || this.props.skip) return;
    var _this$props = this.props,
        threshold = _this$props.threshold,
        root = _this$props.root,
        rootMargin = _this$props.rootMargin,
        trackVisibility = _this$props.trackVisibility,
        delay = _this$props.delay,
        fallbackInView = _this$props.fallbackInView;
    this._unobserveCb = observe(this.node, this.handleChange, {
      threshold: threshold,
      root: root,
      rootMargin: rootMargin,
      // @ts-ignore
      trackVisibility: trackVisibility,
      // @ts-ignore
      delay: delay
    }, fallbackInView);
  };

  _proto.unobserve = function unobserve() {
    if (this._unobserveCb) {
      this._unobserveCb();

      this._unobserveCb = null;
    }
  };

  _proto.render = function render() {
    if (!isPlainChildren(this.props)) {
      var _this$state = this.state,
          inView = _this$state.inView,
          entry = _this$state.entry;
      return this.props.children({
        inView: inView,
        entry: entry,
        ref: this.handleNode
      });
    }

    var _this$props2 = this.props,
        children = _this$props2.children,
        as = _this$props2.as,
        props = _objectWithoutPropertiesLoose(_this$props2, _excluded);

    return /*#__PURE__*/react.createElement(as || 'div', _extends({
      ref: this.handleNode
    }, props), children);
  };

  return InView;
}(react.Component);
InView.displayName = 'InView';
InView.defaultProps = {
  threshold: 0,
  triggerOnce: false,
  initialInView: false
};

/**
 * React Hooks make it easy to monitor the `inView` state of your components. Call
 * the `useInView` hook with the (optional) [options](#options) you need. It will
 * return an array containing a `ref`, the `inView` status and the current
 * [`entry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry).
 * Assign the `ref` to the DOM element you want to monitor, and the hook will
 * report the status.
 *
 * @example
 * ```jsx
 * import React from 'react';
 * import { useInView } from 'react-intersection-observer';
 *
 * const Component = () => {
 *   const { ref, inView, entry } = useInView({
 *       threshold: 0,
 *   });
 *
 *   return (
 *     <div ref={ref}>
 *       <h2>{`Header inside viewport ${inView}.`}</h2>
 *     </div>
 *   );
 * };
 * ```
 */

function useInView(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      threshold = _ref.threshold,
      delay = _ref.delay,
      trackVisibility = _ref.trackVisibility,
      rootMargin = _ref.rootMargin,
      root = _ref.root,
      triggerOnce = _ref.triggerOnce,
      skip = _ref.skip,
      initialInView = _ref.initialInView,
      fallbackInView = _ref.fallbackInView;

  var unobserve = react.useRef();

  var _React$useState = react.useState({
    inView: !!initialInView
  }),
      state = _React$useState[0],
      setState = _React$useState[1];

  var setRef = react.useCallback(function (node) {
    if (unobserve.current !== undefined) {
      unobserve.current();
      unobserve.current = undefined;
    } // Skip creating the observer


    if (skip) return;

    if (node) {
      unobserve.current = observe(node, function (inView, entry) {
        setState({
          inView: inView,
          entry: entry
        });

        if (entry.isIntersecting && triggerOnce && unobserve.current) {
          // If it should only trigger once, unobserve the element after it's inView
          unobserve.current();
          unobserve.current = undefined;
        }
      }, {
        root: root,
        rootMargin: rootMargin,
        threshold: threshold,
        // @ts-ignore
        trackVisibility: trackVisibility,
        // @ts-ignore
        delay: delay
      }, fallbackInView);
    }
  }, // We break the rule here, because we aren't including the actual `threshold` variable
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [// If the threshold is an array, convert it to a string so it won't change between renders.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  Array.isArray(threshold) ? threshold.toString() : threshold, root, rootMargin, triggerOnce, skip, trackVisibility, fallbackInView, delay]);
  /* eslint-disable-next-line */

  (0,react.useEffect)(function () {
    if (!unobserve.current && state.entry && !triggerOnce && !skip) {
      // If we don't have a ref, then reset the state (unless the hook is set to only `triggerOnce` or `skip`)
      // This ensures we correctly reflect the current state - If you aren't observing anything, then nothing is inView
      setState({
        inView: !!initialInView
      });
    }
  });
  var result = [setRef, state.inView, state.entry]; // Support object destructuring, by adding the specific values.

  result.ref = result[0];
  result.inView = result[1];
  result.entry = result[2];
  return result;
}


//# sourceMappingURL=react-intersection-observer.m.js.map

// EXTERNAL MODULE: ./src/components/common/GoogleTagManager/index.ts + 1 modules
var GoogleTagManager = __webpack_require__(40933);
// EXTERNAL MODULE: ./src/components/common/index.tsx + 14 modules
var common = __webpack_require__(20213);
// EXTERNAL MODULE: ./src/components/common/StructuredData/index.ts + 5 modules
var StructuredData = __webpack_require__(60316);
// EXTERNAL MODULE: ./src/uikit/index.tsx + 33 modules
var uikit = __webpack_require__(58598);
// EXTERNAL MODULE: ./src/utils/dateUtils.js
var dateUtils = __webpack_require__(27815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./pages/noleggio-a-lungo-termine/[landing]/[model]/[code].tsx



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
















const {
  formattedYear
} = (0,dateUtils/* getFormattedMonthYear */.P)();
const NltServiceContainer = dynamic_default()(() => __webpack_require__.e(/* import() */ 6166).then(__webpack_require__.bind(__webpack_require__, 86166)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(86166)]
  }
});
const BeforeNltSectionContainer = dynamic_default()(() => __webpack_require__.e(/* import() */ 3417).then(__webpack_require__.bind(__webpack_require__, 13417)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(13417)]
  }
});
const HowNltWorksSectionContainer = dynamic_default()(() => __webpack_require__.e(/* import() */ 9856).then(__webpack_require__.bind(__webpack_require__, 77932)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(77932)]
  }
});
const NltCustomizeOfferModalContainer = dynamic_default()(() => __webpack_require__.e(/* import() */ 2806).then(__webpack_require__.bind(__webpack_require__, 82806)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(82806)]
  }
});
const StickyBarContainer = dynamic_default()(() => __webpack_require__.e(/* import() */ 2067).then(__webpack_require__.bind(__webpack_require__, 52067)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(52067)]
  }
});
const VehicleOptionalsContainer = dynamic_default()(() => __webpack_require__.e(/* import() */ 1526).then(__webpack_require__.bind(__webpack_require__, 91526)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(91526)]
  }
});
const VehicleDetailsContainer = dynamic_default()(() => __webpack_require__.e(/* import() */ 2395).then(__webpack_require__.bind(__webpack_require__, 32395)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(32395)]
  }
});
const SimilarOffersList = dynamic_default()(() => Promise.all(/* import() */[__webpack_require__.e(5061), __webpack_require__.e(7651), __webpack_require__.e(2668), __webpack_require__.e(5711)]).then(__webpack_require__.bind(__webpack_require__, 66328)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(66328)]
  }
});
const PartnershipBanner = dynamic_default()(() => __webpack_require__.e(/* import() */ 50).then(__webpack_require__.bind(__webpack_require__, 40050)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(40050)]
  }
});
const Breadcrumbs = dynamic_default()(() => __webpack_require__.e(/* import() */ 2494).then(__webpack_require__.bind(__webpack_require__, 46384)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(46384)]
  }
});
const OfferGalleryContainer = dynamic_default()(() => Promise.all(/* import() */[__webpack_require__.e(5061), __webpack_require__.e(1953)]).then(__webpack_require__.bind(__webpack_require__, 20326)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(20326)]
  }
});
const OfferDetailsContainer = dynamic_default()(() => __webpack_require__.e(/* import() */ 2639).then(__webpack_require__.bind(__webpack_require__, 2639)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(2639)]
  }
});

const NltOfferPage = ({
  offerData,
  similarOffers,
  variationSearch,
  howNltWorksData
}) => {
  const router = (0,next_router.useRouter)();
  const {
    t
  } = (0,useTranslation/* useTranslation */.$)();
  const {
    0: similarOffersItems,
    1: setSimilarOffersItems
  } = (0,react.useState)([similarOffers.input]);

  if (variationSearch && variationSearch.contractLength && variationSearch.annualMileage && variationSearch.deposit) {
    let {
      contractLength,
      annualMileage,
      deposit
    } = variationSearch;
    contractLength = parseInt(contractLength);
    annualMileage = parseInt(annualMileage);
    deposit = parseInt(deposit);
    const newDefault = offerData.variations.find(variation => variation.contractLength === contractLength && variation.annualMileage === annualMileage && variation.deposit === deposit);

    if (newDefault) {
      const oldDefault = {
        id: offerData.id,
        contractLength: offerData.contractLength,
        annualMileage: offerData.annualMileage,
        deposit: offerData.deposit,
        monthlyRate: offerData.monthlyRate
      };
      offerData.contractLength = newDefault.contractLength;
      offerData.annualMileage = newDefault.annualMileage;
      offerData.deposit = newDefault.deposit;
      offerData.monthlyRate = newDefault.monthlyRate;
      offerData.variations = offerData.variations.filter(variation => variation.contractLength !== contractLength || variation.annualMileage !== annualMileage || variation.deposit !== deposit);
      offerData.variations.push(_objectSpread({}, oldDefault));
    }
  }

  const customizeModalIsOpen = (0,es/* useSelector */.v9)(state => state.nlt.customizeModalIsOpen);
  const [ref, inView] = useInView({
    threshold: 0.5
  });
  (0,react.useEffect)(() => {
    setSimilarOffersItems(similarOffers.predicted);
  }, [similarOffers]);
  const crumbs = [{
    page: 'Home Page',
    href: '/',
    title: 'Home Page'
  }, {
    page: 'Offerte Noleggio a Lungo Termine',
    href: '/noleggio-a-lungo-termine',
    title: 'Offerte Noleggio a Lungo Termine'
  }, {
    page: `${offerData.vehicle.brand}`,
    href: `/noleggio-a-lungo-termine/${offerData.vehicle.brandCode}`,
    title: `${offerData.vehicle.brand}`
  }, {
    page: `${offerData.vehicle.model}`,
    href: `/noleggio-a-lungo-termine/${offerData.vehicle.brandCode}/${offerData.vehicle.modelCode}`,
    title: `${offerData.vehicle.model}`
  }, {
    page: `${offerData.code}`,
    href: router.asPath,
    title: `${offerData.code}`
  }];
  const formattedMetaDataTitle = (0,dateUtils/* replaceDatePlaceholders */.h)(offerData.metaDataTitle);
  const formattedMetaDataDescription = (0,dateUtils/* replaceDatePlaceholders */.h)(offerData.metaDataDescription);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)((styled_jsx_default()), {
      id: "2684451489",
      children: ["#CookiebotWidget{z-index:1 !important;}"]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(common/* Head */.Fb, {
      title: formattedMetaDataTitle || t('nltPage:landingModel.title', {
        brand: offerData.vehicle.brand,
        model: offerData.vehicle.model,
        description: offerData.vehicle.version,
        fuel: offerData.vehicle.engine.fuel,
        year: formattedYear
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(common/* MetaTags */.NR, {
      meta: t(`nltPage:landingModel.meta`, {
        returnObjects: true,
        brand: offerData.vehicle.brand,
        model: offerData.vehicle.model,
        description: offerData.vehicle.version,
        fuel: offerData.vehicle.engine.fuel,
        price: offerData.monthlyRate,
        numMonths: offerData.contractLength,
        metaDataDescription: formattedMetaDataDescription,
        url: `https://www.carplanner.com${router.asPath}`
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(common/* LinkRel */.Mu, {
      rel: "canonical",
      href: `https://www.carplanner.com${router.asPath}`
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(GoogleTagManager/* GtmItem */.w9, {
      data: offerData
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(StructuredData/* NltOffer */.dc, {
      offerData: offerData
    }), offerData.partnership && /*#__PURE__*/(0,jsx_runtime.jsx)(PartnershipBanner, {
      partner: offerData.partnership
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Container */.W2, {
      maxW: "8xl",
      px: {
        base: '1.375rem',
        md: null
      },
      ref: ref,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
        display: {
          base: 'none',
          md: 'flex'
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Breadcrumbs, {
          items: crumbs
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
        mb: "8",
        display: {
          base: 'block',
          md: 'none'
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(OfferGalleryContainer, {
          images: offerData.images,
          badge: offerData.mainTag
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(OfferDetailsContainer, {
          offerData: offerData
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Grid */.rj, {
        templateColumns: "2fr 1fr",
        gap: 4,
        display: {
          base: 'none',
          md: 'grid'
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* GridItem */.P4, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(OfferGalleryContainer, {
            images: offerData.images,
            badge: offerData.mainTag
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* GridItem */.P4, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(OfferDetailsContainer, {
            offerData: offerData
          })
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(NltServiceContainer, {
      title: t('productPage:services.title'),
      services: offerData.services
    }), offerData.description && /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
      bg: "baseWhite",
      pb: "xxl6",
      mt: "xxl6",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Container */.W2, {
        maxW: "7xl",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(uikit/* H3Title */.WX, {
          children: t('productPage:services.offerDescription')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
          textAlign: "left",
          color: "baseDark",
          fontFamily: "Montserrat-Regular",
          fontSize: "1rem",
          letterSpacing: "0.2px",
          lineHeight: "20.8px",
          dangerouslySetInnerHTML: {
            __html: offerData.description
          }
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(VehicleDetailsContainer, {
      vehicle: offerData.vehicle,
      title: t('productPage:vehicleDetails.title', {
        value: `${offerData.vehicle.name} ${offerData.vehicle.version}`
      })
    }), offerData.features.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(VehicleOptionalsContainer, {
      optionals: offerData.features
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(HowNltWorksSectionContainer, {
      content: howNltWorksData
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(BeforeNltSectionContainer, {}), similarOffersItems && similarOffersItems.length ? /*#__PURE__*/(0,jsx_runtime.jsx)(SimilarOffersList, {
      title: t('productPage:similarOffersTitle'),
      action: t('indexPage:nlt_offers.action'),
      alt: t('indexPage:nlt_offers.alt'),
      bgColor: "baseNeutral.100",
      href: "/noleggio-a-lungo-termine",
      offers: similarOffersItems,
      numPerView: 4
    }) : null, /*#__PURE__*/(0,jsx_runtime.jsx)(StickyBarContainer, {
      offerData: offerData,
      visible: !inView
    }), customizeModalIsOpen && /*#__PURE__*/(0,jsx_runtime.jsx)(NltCustomizeOfferModalContainer, {
      offerData: offerData
    })]
  });
};

var __N_SSP = true;
/* harmony default export */ var _code_ = (NltOfferPage);

/***/ }),

/***/ 60316:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "aG": function() { return /* reexport */ StructuredData_Breadcrumb; },
  "By": function() { return /* reexport */ StructuredData_Faq; },
  "TR": function() { return /* reexport */ StructuredData_Logo; },
  "dc": function() { return /* reexport */ StructuredData_NltOffer; },
  "_6": function() { return /* reexport */ StructuredData_OfferList; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/containers/data/brands.json
var brands = __webpack_require__(11669);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/common/StructuredData/NltOffer.tsx





const NltOffer = ({
  offerData
}) => {
  const data = {
    "@context": "https://schema.org/",
    "@type": "Vehicle",
    "name": `${offerData.vehicle.name} - Noleggio a Lungo Termine`,
    "image": offerData.images.map(image => image.src),
    "description": `${offerData.vehicle.name} a ${offerData.monthlyRate}€ al mese! Con CarPlanner hai manutenzione, assicurazione, bollo, tassa di proprietà a molti altri servizi, inclusi in un unico canone mensile.`,
    "sku": offerData.code,
    "mpn": offerData.id,
    "fuelType": offerData.vehicle.engine.fuel,
    "brand": {
      "@type": "Brand",
      "name": offerData.vehicle.brand,
      "logo": brands.find(brand => brand.href === offerData.vehicle.brandCode).image
    },
    "offers": {
      "@type": "Offer",
      "url": `https://www.carplanner.com/noleggio-a-lungo-termine/${offerData.vehicle.brandCode}/${offerData.vehicle.modelCode}/${offerData.code}`,
      "priceCurrency": 'EUR',
      "price": offerData.monthlyRate,
      "itemCondition": 'https://schema.org/NewCondition',
      "availability": 'https://schema.org/LimitedAvailability',
      "seller": {
        '@type': 'Organization',
        "name": "CarPlanner",
        "url": "https://www.carplanner.com/",
        "logo": "https://static1.carplanner.com/logos/carplanner.svg"
      }
    }
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
      type: "application/ld+json",
      id: "structuredDataNltOffer",
      dangerouslySetInnerHTML: {
        __html: JSON.stringify(data)
      }
    })
  });
};

/* harmony default export */ var StructuredData_NltOffer = (NltOffer);
;// CONCATENATED MODULE: ./src/components/common/StructuredData/Logo.tsx




const Logo = () => {
  const data = {
    "@context": "https://schema.org/",
    "@type": "Organization",
    "name": "Noleggio a Lungo Termine",
    "url": "https://www.carplanner.com/",
    "logo": "https://static1.carplanner.com/logos/carplanner.svg"
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
      type: "application/ld+json",
      id: "structuredDataLogo",
      dangerouslySetInnerHTML: {
        __html: JSON.stringify(data)
      }
    })
  });
};

/* harmony default export */ var StructuredData_Logo = (Logo);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./server/api/nlt.ts
var nlt = __webpack_require__(27449);
;// CONCATENATED MODULE: ./src/components/common/StructuredData/Faq.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






const Faq = () => {
  const {
    0: faqSingleItems,
    1: setFaqSingleItems
  } = (0,react.useState)([]);
  (0,react.useEffect)(() => {
    async function getFaqs() {
      const faqs = await (0,nlt/* getFaqAutoCompleteItems */.eF)();
      setFaqSingleItems(faqs.data);
    }

    if (!faqSingleItems.length) {
      getFaqs();
    }
  });
  let faqItems = {};
  faqSingleItems.forEach(faqItem => {
    faqItems[faqItem.uri] = faqItems[faqItem.uri] || [];
    faqItems[faqItem.uri].push(_objectSpread({}, faqItem));
  });
  const data = {
    "@context": "https://schema.org/",
    "@type": "FAQPage",
    "mainEntity": Object.keys(faqItems).map(faqUri => ({
      "@type": "Question",
      "url": `https://www.carplanner.com/noleggio-a-lungo-termine/faq/${faqUri}`,
      "name": faqItems[faqUri][0].title,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faqItems[faqUri].map(faqItem => `<p><strong>${faqItem.q || ''}</strong> ${faqItem.a || ''}</p>`).join('')
      }
    }))
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
      type: "application/ld+json",
      id: "structuredDataFaq",
      dangerouslySetInnerHTML: {
        __html: JSON.stringify(data)
      }
    })
  });
};

/* harmony default export */ var StructuredData_Faq = (Faq);
;// CONCATENATED MODULE: ./src/components/common/StructuredData/Breadcrumb.tsx




const Breadcrumb = ({
  breadcrumbData
}) => {
  const data = {
    "@context": "https://schema.org/",
    "@type": "BreadcrumbList",
    "itemListElement": breadcrumbData.map((crumbItem, idx) => ({
      "@type": "ListItem",
      "position": idx + 1,
      "name": crumbItem.title,
      "item": `https://carplanner.com${crumbItem.href}`
    }))
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
      type: "application/ld+json",
      id: "structuredDataBreadcrumb",
      dangerouslySetInnerHTML: {
        __html: JSON.stringify(data)
      }
    })
  });
};

/* harmony default export */ var StructuredData_Breadcrumb = (Breadcrumb);
;// CONCATENATED MODULE: ./src/components/common/StructuredData/OfferList.tsx




const OfferList = ({
  items
}) => {
  const data = {
    "@context": "https://schema.org/",
    "@type": "ItemList",
    "numberOfItems": items.length,
    "itemListElement": items.map((item, idx) => ({
      "@type": "ListItem",
      "position": idx,
      "url": item
    }))
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
      type: "application/ld+json",
      id: "structuredDataOfferList",
      dangerouslySetInnerHTML: {
        __html: JSON.stringify(data)
      }
    })
  });
};

/* harmony default export */ var StructuredData_OfferList = (OfferList);
;// CONCATENATED MODULE: ./src/components/common/StructuredData/index.ts






/***/ }),

/***/ 20213:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Do": function() { return /* reexport */ Offers_FilterSwitch; },
  "dB": function() { return /* reexport */ Offers_FilterTag; },
  "TY": function() { return /* reexport */ Offers_FilterTagCheckbox; },
  "Sz": function() { return /* reexport */ Offers_FilterTagImage; },
  "Fb": function() { return /* reexport */ common_Head; },
  "Mu": function() { return /* reexport */ LinkRel; },
  "NR": function() { return /* reexport */ common_MetaTags; },
  "$j": function() { return /* reexport */ common_Spinner; }
});

// UNUSED EXPORTS: SpaceL, SpaceXS, SpaceXXL, SpaceXXL4, SpaceXXL5, SpaceXXL6, Title

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(53918);
;// CONCATENATED MODULE: ./src/components/common/Title.tsx

const Title = styled_components_browser_esm["default"].h2.withConfig({
  displayName: "Title",
  componentId: "sc-ajob4w-0"
})(["margin-top:25px;margin-bottom:15px;font-size:30px;"]);
/* harmony default export */ var common_Title = ((/* unused pure expression or super */ null && (Title)));
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 6 modules
var useTranslation = __webpack_require__(18132);
// EXTERNAL MODULE: ./src/containers/data/slider.json
var slider = __webpack_require__(34755);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/common/Head.tsx








const Head = ({
  title
}) => {
  const {
    t
  } = (0,useTranslation/* useTranslation */.$)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("title", {
      children: [title || t('common:header.title'), ' ', "| CarPlanner"]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "preload",
      crossOrigin: "anonymous",
      type: "font/woff2",
      href: "https://static1.carplanner.com/fonts/Montserrat-Regular.woff2",
      as: "font"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "preload",
      crossOrigin: "anonymous",
      type: "font/woff2",
      href: "https://static1.carplanner.com/fonts/Montserrat-Medium.woff2",
      as: "font"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "preload",
      crossOrigin: "anonymous",
      type: "font/woff2",
      href: "https://static1.carplanner.com/fonts/Montserrat-SemiBold.woff2",
      as: "font"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "preload",
      as: "image",
      href: slider/* image */.BH
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "preload",
      as: "image",
      href: slider/* boxes.0.image */.qk[0].image
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "preload",
      as: "image",
      href: slider/* boxes.1.image */.qk[1].image
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((script_default()), {
      id: "Cookiebot",
      src: "https://consent.cookiebot.com/uc.js",
      "data-cbid": "93243ddb-bf78-4f8b-b7bc-52a29e9f53e5",
      "data-blockingmode": "auto",
      type: "text/javascript",
      async: true
    })]
  });
};

/* harmony default export */ var common_Head = (Head);
;// CONCATENATED MODULE: ./src/components/common/MetaTags.tsx




const MetaTags = ({
  meta
}) => /*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
  children: meta.length > 0 && meta.map(tag => {
    if (tag.name) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: tag.name,
        content: tag.override && tag.override.trim() !== '' ? tag.override : tag.content ?? ''
      }, tag.name);
    }

    if (tag.property) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: tag.property,
        content: tag.override && tag.override.trim() !== '' ? tag.override : tag.content ?? ''
      }, tag.property);
    }

    return null;
  })
});

/* harmony default export */ var common_MetaTags = (MetaTags);
const LinkRel = ({
  rel,
  href,
  crossOrigin,
  type,
  as
}) => {
  let url = '';

  if (rel === 'canonical' && href.indexOf('?') >= 0) {
    // rimuove eventuali parametri querystring
    [url] = href.split('?');
  } else {
    url = href;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: rel,
      href: url,
      crossOrigin: crossOrigin || null,
      type: type || null,
      as: as || null
    })
  });
};
// EXTERNAL MODULE: ./node_modules/@chakra-ui/hooks/dist/index.esm.js
var index_esm = __webpack_require__(39653);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/modal/dist/index.esm.js + 1 modules
var dist_index_esm = __webpack_require__(83292);
;// CONCATENATED MODULE: ./src/components/common/Spinner.tsx





const LogoSpinner = () => /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  x: "0px",
  y: "0px",
  viewBox: "0 0 50 35",
  children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fill: "#2EC58D",
        d: "M40.5,19c-3.6-3.4-9.2-3.2-12.6,0.4l-2,2.2l-0.9,1v0l-0.7,0.8l-5.1,5.5c0,0,0,0,0,0c0,0-0.1,0.1-0.1,0.1 c-1.3,1.3-3.1,1.7-4.8,1.2c0,0,0,0,0,0c-0.1,0-0.3-0.1-0.4-0.1c0,0,0,0,0,0c-0.1,0-0.2-0.1-0.4-0.2c0,0,0,0,0,0 c-0.1-0.1-0.2-0.1-0.3-0.2c0,0,0,0,0,0c-0.1-0.1-0.2-0.2-0.3-0.2c0,0,0,0,0,0c-0.1,0-0.1-0.1-0.2-0.1c0,0,0,0,0,0 c0,0-0.1-0.1-0.1-0.1l0,0c-1.9-1.8-2-4.9-0.2-6.8c1.8-1.9,4.9-2,6.8-0.2c0.6,0.5,1,1.2,1.2,1.8l3-3.2c-0.4-0.6-0.8-1.2-1.4-1.7 c-3.6-3.4-9.2-3.2-12.6,0.4c-2.9,3.1-3.2,7.6-1,11c0,0.1,0.1,0.1,0.1,0.2c0,0,0,0.1,0.1,0.1c0.1,0.1,0.1,0.2,0.2,0.2 c0,0,0.1,0.1,0.1,0.1c0.1,0.1,0.1,0.1,0.2,0.2C8.9,31.3,9,31.4,9,31.4c0,0,0.1,0.1,0.1,0.1c0.1,0.1,0.1,0.2,0.2,0.2 c0,0,0,0.1,0.1,0.1c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0.1,0.1,0.1,0.1c0,0,0.1,0.1,0.1,0.1c0.1,0.1,0.1,0.1,0.2,0.2 c0.1,0.1,0.1,0.1,0.1,0.1c0,0,0,0,0,0c0,0,0,0,0,0c3.6,2.8,8.8,2.5,12-0.9l2-2.1c0,0,0.9-1,0.9-1l0.7-0.8l5.1-5.6c0,0,0,0,0,0 c1.8-1.9,4.9-2,6.8-0.2c1.9,1.8,2,4.9,0.2,6.8c-1.8,1.9-4.9,2-6.8,0.2c-0.6-0.5-1-1.2-1.2-1.8l-3,3.2c0.4,0.6,0.8,1.2,1.4,1.7 c3.6,3.4,9.2,3.2,12.6-0.4C44.3,28,44.1,22.3,40.5,19z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fill: "#2EC58D",
        d: "M45.8,7.7C42.3,2.6,36.7,0,29.2,0C22.8,0,15.6,3,9.5,8.3C3.6,13.4,0,19.7,0,25.1h5.4c0-3.7,2.9-8.6,7.7-12.7 c5-4.3,11-6.9,16.1-6.9c2.3,0,4.3,0.3,6,0.8c0,0,0.1,0,0.1,0.1c4.7,2.1,7.1,5.9,8.3,9.5c0.7,2.6,1.1,5.7,1.1,9.3l5.4,0 c0,0,0,0,0,0h0C50.1,17.6,48.7,11.9,45.8,7.7z"
      })]
    })
  })
});

const Spinner = ({
  isVisible
}) => {
  const {
    onClose
  } = (0,index_esm/* useDisclosure */.qY)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Modal */.u_, {
    isOpen: isVisible,
    onClose: onClose,
    isCentered: true,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* ModalOverlay */.ZA, {
      bg: "blackAlpha.700"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* ModalContent */.hz, {
      background: "transparent",
      alignItems: "center",
      boxShadow: "none",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "spinner-circle"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "spinner-logo",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(LogoSpinner, {})
      })]
    })]
  });
};

/* harmony default export */ var common_Spinner = (Spinner);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/index.esm.js
var button_dist_index_esm = __webpack_require__(47741);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icons/dist/index.esm.js
var icons_dist_index_esm = __webpack_require__(3382);
// EXTERNAL MODULE: ./src/themes/index.tsx + 3 modules
var themes = __webpack_require__(37930);
;// CONCATENATED MODULE: ./src/components/common/Offers/FilterTag.tsx






const FilterTag = ({
  isSelected,
  hasCloseButton,
  label,
  onClick
}) => {
  const {
    0: isMounted,
    1: setMount
  } = (0,react.useState)(false);
  (0,react.useEffect)(() => {
    setMount(true);
  }, []);

  if (!isMounted) {
    return null;
  }

  const bgColor = isSelected ? themes/* theme.colors.primaryGreen.300 */.r.colors.primaryGreen[300] : 'white';
  return /*#__PURE__*/(0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
    color: themes/* theme.colors.primaryGreen.900 */.r.colors.primaryGreen[900],
    variant: "outline",
    fontFamily: "Montserrat-Medium",
    fontWeight: "normal",
    size: "xs",
    h: "32px",
    mr: 1,
    my: 1,
    borderRadius: 4,
    bg: bgColor,
    _hover: {
      backgroundColor: bgColor
    },
    borderColor: themes/* theme.colors.primaryGreen.300 */.r.colors.primaryGreen[300],
    userSelect: "none",
    onClick: onClick,
    rightIcon: hasCloseButton ? /*#__PURE__*/(0,jsx_runtime.jsx)(icons_dist_index_esm/* CloseIcon */.Tw, {
      boxSize: "0.7rem"
    }) : undefined,
    children: label
  });
};

/* harmony default export */ var Offers_FilterTag = (FilterTag);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/checkbox/dist/index.esm.js + 1 modules
var checkbox_dist_index_esm = __webpack_require__(9135);
;// CONCATENATED MODULE: ./src/components/common/Offers/FilterTagCheckbox.tsx





const FilterTagCheckbox = ({
  isChecked,
  label,
  onChange
}) => /*#__PURE__*/(0,jsx_runtime.jsx)(checkbox_dist_index_esm/* Checkbox */.XZ, {
  fontFamily: "Montserrat-Medium",
  color: "baseDark",
  borderColor: themes/* theme.colors.primaryGreen.900 */.r.colors.primaryGreen[900],
  colorScheme: "primaryGreenCheckboxFilter",
  isChecked: isChecked,
  display: "block",
  size: "lg",
  lineHeight: "1.2",
  mb: "s",
  className: "filterCheck",
  onChange: onChange,
  children: label
});

/* harmony default export */ var Offers_FilterTagCheckbox = (FilterTagCheckbox);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var layout_dist_index_esm = __webpack_require__(48641);
;// CONCATENATED MODULE: ./src/components/common/Offers/FilterTagImage.tsx







const FilterTagImage = ({
  isSelected,
  label,
  icon,
  iconAlt,
  onClick,
  isMobile
}) => {
  const borderColor = isSelected ? `${themes/* theme.colors.green.600 */.r.colors.green[600]}, 0 2px 8px 0 rgba(44, 190, 97, 0.13)` : themes/* theme.colors.borders.grey */.r.colors.borders.grey;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(layout_dist_index_esm/* Badge */.Ct, {
    suppressHydrationWarning: true,
    as: "button",
    variant: "outline",
    p: 2,
    m: 1,
    h: isMobile ? '4.563rem' : '4.688rem',
    w: isMobile ? '5.625rem' : '',
    borderRadius: 4,
    textTransform: "none",
    boxShadow: `inset 0 0 0px 1px ${borderColor}`,
    color: "baseNeutral.700",
    onClick: onClick,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
      src: icon,
      alt: iconAlt,
      width: "40",
      height: "40"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      children: label
    })]
  });
};

/* harmony default export */ var Offers_FilterTagImage = (FilterTagImage);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/switch/dist/index.esm.js
var switch_dist_index_esm = __webpack_require__(68185);
;// CONCATENATED MODULE: ./src/components/common/Offers/FilterSwitch.tsx






const FilterSwitch = ({
  title,
  label,
  isSelected,
  onChange
}) => {
  const {
    0: checked,
    1: setChecked
  } = (0,react.useState)(isSelected);
  const {
    0: isMounted,
    1: setMount
  } = (0,react.useState)(false);
  (0,react.useEffect)(() => {
    setChecked(isSelected);
  }, [isSelected]);
  (0,react.useEffect)(() => {
    setMount(true);
  }, []);

  if (!isMounted) {
    return null;
  }

  const onSwitchChange = evt => {
    const {
      target: {
        value
      }
    } = evt;
    setChecked(value === '1');
    onChange(evt);
    return value === '1';
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(layout_dist_index_esm/* Box */.xu, {
      flex: "1",
      textAlign: "left",
      textTransform: "uppercase",
      fontFamily: "Montserrat-SemiBold",
      children: title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(layout_dist_index_esm/* Box */.xu, {
      as: "span",
      fontFamily: "Montserrat-Medium",
      fontSize: "0.875rem",
      color: "#656b72",
      children: label
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(switch_dist_index_esm/* Switch */.r, {
      colorScheme: "green",
      isChecked: checked,
      float: "right",
      value: "1",
      onChange: onSwitchChange
    })]
  });
};

/* harmony default export */ var Offers_FilterSwitch = (FilterSwitch);
;// CONCATENATED MODULE: ./src/components/common/Spaces/xs.tsx



const StyledSpace = styled_components_browser_esm["default"].span.withConfig({
  displayName: "xs__StyledSpace",
  componentId: "sc-jsscb1-0"
})(["display:block;height:", ";"], ({
  theme
}) => theme.spaces.spacing_xs);

const SpaceXS = () => /*#__PURE__*/_jsx(StyledSpace, {
  children: ''
});

/* harmony default export */ var xs = ((/* unused pure expression or super */ null && (SpaceXS)));
;// CONCATENATED MODULE: ./src/components/common/Spaces/l.tsx



const l_StyledSpace = styled_components_browser_esm["default"].span.withConfig({
  displayName: "l__StyledSpace",
  componentId: "sc-1jip8x3-0"
})(["display:block;height:", ";"], ({
  theme
}) => theme.spaces.spacing_l);

const SpaceL = () => /*#__PURE__*/_jsx(l_StyledSpace, {
  children: ''
});

/* harmony default export */ var l = ((/* unused pure expression or super */ null && (SpaceL)));
;// CONCATENATED MODULE: ./src/components/common/Spaces/xxl.tsx



const xxl_StyledSpace = styled_components_browser_esm["default"].span.withConfig({
  displayName: "xxl__StyledSpace",
  componentId: "sc-k5154a-0"
})(["display:block;height:", ";"], ({
  theme
}) => theme.spaces.spacing_xxl);

const SpaceXXL = () => /*#__PURE__*/_jsx(xxl_StyledSpace, {
  children: ''
});

/* harmony default export */ var xxl = ((/* unused pure expression or super */ null && (SpaceXXL)));
;// CONCATENATED MODULE: ./src/components/common/Spaces/xxl_4.tsx



const xxl_4_StyledSpace = styled_components_browser_esm["default"].span.withConfig({
  displayName: "xxl_4__StyledSpace",
  componentId: "sc-1fuyqpr-0"
})(["display:block;height:", ";"], ({
  theme
}) => theme.spaces.spacing_xxl_4);

const SpaceXXL4 = () => /*#__PURE__*/_jsx(xxl_4_StyledSpace, {
  children: ''
});

/* harmony default export */ var xxl_4 = ((/* unused pure expression or super */ null && (SpaceXXL4)));
;// CONCATENATED MODULE: ./src/components/common/Spaces/xxl_5.tsx



const xxl_5_StyledSpace = styled_components_browser_esm["default"].span.withConfig({
  displayName: "xxl_5__StyledSpace",
  componentId: "sc-16fb0l1-0"
})(["display:block;height:", ";"], ({
  theme
}) => theme.spaces.spacing_xxl_5);

const SpaceXXL5 = () => /*#__PURE__*/_jsx(xxl_5_StyledSpace, {
  children: ''
});

/* harmony default export */ var xxl_5 = ((/* unused pure expression or super */ null && (SpaceXXL5)));
;// CONCATENATED MODULE: ./src/components/common/Spaces/xxl_6.tsx



const xxl_6_StyledSpace = styled_components_browser_esm["default"].span.withConfig({
  displayName: "xxl_6__StyledSpace",
  componentId: "sc-8dq84s-0"
})(["display:block;height:", ";"], ({
  theme
}) => theme.spaces.spacing_xxl_6);

const SpaceXXL6 = () => /*#__PURE__*/_jsx(xxl_6_StyledSpace, {
  children: ''
});

/* harmony default export */ var xxl_6 = ((/* unused pure expression or super */ null && (SpaceXXL6)));
;// CONCATENATED MODULE: ./src/components/common/index.tsx
//TODO move to uikit















/***/ }),

/***/ 27815:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ getFormattedMonthYear; },
/* harmony export */   "h": function() { return /* binding */ replaceDatePlaceholders; }
/* harmony export */ });
const currentDate = new Date();
const monthYear = currentDate.toLocaleString('it-IT', {
  month: 'long',
  year: 'numeric'
});
const formattedMonth = monthYear.charAt(0).toUpperCase() + monthYear.slice(1, -5);
const formattedYear = currentDate.getFullYear();
const getFormattedMonthYear = () => {
  return {
    formattedMonth,
    formattedYear
  };
};
const replaceDatePlaceholders = text => {
  if (!text) return null; // Fallback se il testo è null o undefined

  return text.replace('{{month}}', formattedMonth).replace('{{year}}', String(formattedYear));
};

/***/ }),

/***/ 99249:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/noleggio-a-lungo-termine/[landing]/[model]/[code]",
      function () {
        return __webpack_require__(30753);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 11669:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('[{"href":"alfa-romeo","image":"https://static1.carplanner.com/cars/brands/alfa-romeo.svg","name":"Alfa Romeo","slug":"ALF"},{"href":"abarth","image":"https://static1.carplanner.com/cars/brands/abarth.svg","name":"Abarth","slug":"ABA"},{"href":"aston-martin","image":"https://static1.carplanner.com/cars/brands/aston-martin.svg","name":"Aston Martin","slug":"AST"},{"href":"audi","image":"https://static1.carplanner.com/cars/brands/audi.svg","name":"Audi","slug":"AUD"},{"href":"bentley","image":"https://static1.carplanner.com/cars/brands/bentley.svg","name":"Bentley","slug":"BEN"},{"href":"bmw","image":"https://static1.carplanner.com/cars/brands/bmw.svg","name":"BMW","slug":"BMW"},{"href":"cadillac","image":"https://static1.carplanner.com/cars/brands/cadillac.svg","name":"Cadillac","slug":"CAD"},{"href":"chevrolet","image":"https://static1.carplanner.com/cars/brands/chevrolet.svg","name":"Chevrolet","slug":"CHC"},{"href":"chrysler","image":"https://static1.carplanner.com/cars/brands/chrysler.svg","name":"Chrysler","slug":"CHR"},{"href":"citroen","image":"https://static1.carplanner.com/cars/brands/citroen.svg","name":"Citroen","slug":"CIT"},{"href":"cupra","image":"https://static1.carplanner.com/cars/brands/cupra.svg","name":"Cupra","slug":"CUP"},{"href":"dacia","image":"https://static1.carplanner.com/cars/brands/dacia.svg","name":"Dacia","slug":"DAC"},{"href":"dr","image":"https://static1.carplanner.com/cars/brands/dr.svg","name":"DR","slug":"DRM"},{"href":"ds","image":"https://static1.carplanner.com/cars/brands/ds.svg","name":"DS","slug":"DSA"},{"href":"ferrari","image":"https://static1.carplanner.com/cars/brands/ferrari.svg","name":"Ferrari","slug":"FER"},{"href":"fiat","image":"https://static1.carplanner.com/cars/brands/fiat.svg","name":"Fiat","slug":"FIA"},{"href":"ford","image":"https://static1.carplanner.com/cars/brands/ford.svg","name":"Ford","slug":"FOR"},{"href":"honda","image":"https://static1.carplanner.com/cars/brands/honda.svg","name":"Honda","slug":"HON"},{"href":"hyundai","image":"https://static1.carplanner.com/cars/brands/hyundai.svg","name":"Hyundai","slug":"HYU"},{"href":"infiniti","image":"https://static1.carplanner.com/cars/brands/infiniti.svg","name":"Infiniti","slug":"INF"},{"href":"jaguar","image":"https://static1.carplanner.com/cars/brands/jaguar.svg","name":"Jaguar","slug":"JAG"},{"href":"jeep","image":"https://static1.carplanner.com/cars/brands/jeep.svg","name":"Jeep","slug":"JEE"},{"href":"kia","image":"https://static1.carplanner.com/cars/brands/kia.svg","name":"Kia","slug":"KIA"},{"href":"lamborghini","image":"https://static1.carplanner.com/cars/brands/lamborghini.svg","name":"Lamborghini","slug":"LAM"},{"href":"lancia","image":"https://static1.carplanner.com/cars/brands/lancia.svg","name":"Lancia","slug":"LAN"},{"href":"land-rover","image":"https://static1.carplanner.com/cars/brands/land-rover.svg","name":"Land Rover","slug":"LND"},{"href":"lexus","image":"https://static1.carplanner.com/cars/brands/lexus.svg","name":"Lexus","slug":"LEX"},{"href":"lotus","image":"https://static1.carplanner.com/cars/brands/lotus.svg","name":"Lotus","slug":"LOT"},{"href":"mahindra","image":"https://static1.carplanner.com/cars/brands/mahindra.svg","name":"Mahindra","slug":"MAH"},{"href":"maserati","image":"https://static1.carplanner.com/cars/brands/maserati.svg","name":"Maserati","slug":"MAS"},{"href":"mazda","image":"https://static1.carplanner.com/cars/brands/mazda.svg","name":"Mazda","slug":"MAZ"},{"href":"mclaren","image":"https://static1.carplanner.com/cars/brands/mclaren.svg","name":"McLaren","slug":"MCL"},{"href":"mercedes","image":"https://static1.carplanner.com/cars/brands/mercedes.svg","name":"Mercedes-Benz","slug":"MER"},{"href":"mg","image":"https://static1.carplanner.com/cars/brands/mg.svg","name":"MG","slug":"MGG"},{"href":"mini","image":"https://static1.carplanner.com/cars/brands/mini.svg","name":"Mini","slug":"MIN"},{"href":"mitsubishi","image":"https://static1.carplanner.com/cars/brands/mitsubishi.svg","name":"Mitsubishi","slug":"MIT"},{"href":"nissan","image":"https://static1.carplanner.com/cars/brands/nissan.svg","name":"Nissan","slug":"NIS"},{"href":"opel","image":"https://static1.carplanner.com/cars/brands/opel.svg","name":"Opel","slug":"OPE"},{"href":"peugeot","image":"https://static1.carplanner.com/cars/brands/peugeot.svg","name":"Peugeot","slug":"PEU"},{"href":"porsche","image":"https://static1.carplanner.com/cars/brands/porsche.svg","name":"Porsche","slug":"POR"},{"href":"renault","image":"https://static1.carplanner.com/cars/brands/renault.svg","name":"Renault","slug":"REN"},{"href":"rolls-royce","image":"https://static1.carplanner.com/cars/brands/rolls-royce.svg","name":"Rolls-Royce","slug":"ROL"},{"href":"seat","image":"https://static1.carplanner.com/cars/brands/seat.svg","name":"Seat","slug":"SEA"},{"href":"skoda","image":"https://static1.carplanner.com/cars/brands/skoda.svg","name":"Skoda","slug":"SKO"},{"href":"smart","image":"https://static1.carplanner.com/cars/brands/smart.svg","name":"Smart","slug":"SMA"},{"href":"ssangyong","image":"https://static1.carplanner.com/cars/brands/ssangyong.svg","name":"Ssangyong","slug":"SAN"},{"href":"subaru","image":"https://static1.carplanner.com/cars/brands/subaru.svg","name":"Subaru","slug":"SUB"},{"href":"suzuki","image":"https://static1.carplanner.com/cars/brands/suzuki.svg","name":"Suzuki","slug":"SUZ"},{"href":"tesla","image":"https://static1.carplanner.com/cars/brands/tesla.svg","name":"Tesla","slug":"TES"},{"href":"toyota","image":"https://static1.carplanner.com/cars/brands/toyota.svg","name":"Toyota","slug":"TOY"},{"href":"volkswagen","image":"https://static1.carplanner.com/cars/brands/volkswagen.svg","name":"Volkswagen","slug":"VLK"},{"href":"volvo","image":"https://static1.carplanner.com/cars/brands/volvo.svg","name":"Volvo","slug":"VOL"}]');

/***/ }),

/***/ 34755:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"TN":"Lasciati guidare verso\\nla scelta dell’auto migliore","BH":"https://static1.carplanner.com/website/assets/index-head.jpg","Oc":"CarPlanner ti propone le offerte di auto nuove più competitive\\nsul mercato sia per l’acquisto che per il Noleggio a Lungo Termine","qk":[{"image":"https://static1.carplanner.com/website/assets/noleggia-la-tua-auto-a-lungo-termine-2.png","title":"Noleggia la tua auto a lungo termine","description":"Cerchi un’alternativa all’acquisto di un’auto?","action":"Scopri di più","actionMobile":"Scopri","href":"/noleggio-a-lungo-termine","alt":"Scopri tutte le offerte di Noleggio a Lungo Termine","target":"_self"},{"image":"https://static1.carplanner.com/website/assets/acquista-la-tua-nuova-auto-online-2.png","title":"Acquista la tua nuova auto online","description":"Cerchi la tua\\nnuova auto?","action":"Scopri di più","actionMobile":"Scopri","href":"/offerte-auto","alt":"Scopri tutte le offerte di Auto in Vendita","target":"_self"}],"PX":{"a":"Contattaci ora"}}');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6741,7130,3877,7855,7120,9774,2888,179], function() { return __webpack_exec__(99249); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);